import { Control } from '../../business-objects/control/control.model';
import { FeeControlConfig } from './fee-control-config.model';

export class FeeControl extends Control {
    config: FeeControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/fee/fee-control.model.ts